import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
  const customScript = document.createElement('script');
  customScript.type = 'text/javascript';
  customScript.text = `
        window['_fs_host'] = 'eu1.fullstory.com';
        window['_fs_script'] = 'edge.eu1.fullstory.com/s/fs.js';
        window['_fs_org'] = 'o-7E9Q-eu1';
        window['_fs_namespace'] = 'FS';
        !function(m,n,e,t,l,o,g,y){
          var s,f,a=function(h){
            return !(h in m) || (m.console && m.console.log && m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'), !1);
          };
          if (a(e)) return;
          function p(b){
            var h, d = [];
            function j(){
              h && (d.forEach(function(b){
                var d;
                try {
                  d = b[h[0]] && b[h[0]](h[1]);
                } catch (h) {
                  return void (b[3] && b[3](h));
                }
                d && d.then ? d.then(b[2], b[3]) : b[2] && b[2](d);
              }), d.length = 0);
            }
            function r(b){
              return function(d){
                h || (h = [b, d], j());
              };
            }
            return b(r(0), r(1)), {
              then: function(b, h){
                return p(function(r, i){
                  d.push([b, h, r, i]), j();
                });
              }
            };
          }
          g = m[e] = function(){
            var b = function(b, d, j, r){
              function i(i, c){
                h(b, d, j, i, c, r);
              }
              r = r || 2;
              var c, u = /Async$/;
              return u.test(b) ? (b = b.replace(u, ""), "function" == typeof Promise ? new Promise(i) : h(b, d, j, i, i, r)) : h(b, d, j, i, c, r);
            };
            function h(h, d, j, r, i, c){
              return b._api ? b._api(h, d, j, r, i, c) : (b.q && b.q.push([h, d, j, r, i, c]), null);
            }
            return b.q = [], b;
          }();
          y = function(b){
            function h(h){
              "function" == typeof h[4] && h[4](new Error(b));
            }
            var d = g.q;
            if (d){
              for (var j = 0; j < d.length; j++) h(d[j]);
              d.length = 0, d.push = h;
            }
          };
          (o = n.createElement(t)).async = !0;
          o.crossOrigin = "anonymous";
          o.src = "https://" + l;
          o.onerror = function(){
            y("Error loading " + l);
          };
          var b = n.getElementsByTagName(t)[0];
          b && b.parentNode ? b.parentNode.insertBefore(o, b) : n.head.appendChild(o);
        }(window, document, window._fs_namespace, "script", window._fs_script);
      `;
  document.head.appendChild(customScript);
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
